'use client';
import React from 'react';
import { GENERATION_DATA } from '@/data/mockData';
import { GitBranch } from 'lucide-react';

export default function GenerationBreakdownTable() {
  const total = GENERATION_DATA?.reduce((s, g) => s + g?.bonus, 0);
  const totalGSV = GENERATION_DATA?.reduce((s, g) => s + g?.gsv, 0);

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <GitBranch size={14} className="text-violet-400" />
          <h3 className="text-sm font-semibold text-zinc-300">Generation Commission Breakdown</h3>
        </div>
        <span className="text-xs font-bold text-emerald-400 font-mono">${total?.toFixed(0)} total</span>
      </div>
      <table className="w-full">
        <thead>
          <tr className="border-b border-zinc-800">
            {['Generation', 'Exec Count', 'GSV', 'Bonus %', 'Breakaway', 'Commission', '% of Total']?.map(h => (
              <th key={`gth-${h}`} className="text-left text-[9px] font-semibold uppercase tracking-wider text-zinc-600 px-2 py-2">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {GENERATION_DATA?.map(g => {
            const pct = total > 0 ? (g?.bonus / total) * 100 : 0;
            return (
              <tr key={`grow-${g?.gen}`} className="border-b border-zinc-800/40 hover:bg-zinc-800/20 transition-colors">
                <td className="px-2 py-2.5">
                  <span className="text-sm font-bold text-violet-400 font-mono">{g?.gen}</span>
                </td>
                <td className="px-2 py-2.5"><span className="text-sm font-mono text-zinc-300">{g?.execCount}</span></td>
                <td className="px-2 py-2.5"><span className="text-sm font-mono text-zinc-300">{(g?.gsv / 1000)?.toFixed(1)}K</span></td>
                <td className="px-2 py-2.5">
                  <span className={`text-sm font-semibold font-mono ${g?.bonusPct === 5 ? 'text-emerald-400' : 'text-amber-400'}`}>{g?.bonusPct}%</span>
                </td>
                <td className="px-2 py-2.5">
                  <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${g?.isBreakaway ? 'bg-violet-500/15 text-violet-400' : 'bg-zinc-700/40 text-zinc-500'}`}>
                    {g?.isBreakaway ? 'Yes' : 'No'}
                  </span>
                </td>
                <td className="px-2 py-2.5"><span className="text-sm font-bold font-mono text-emerald-400">${g?.bonus?.toFixed(0)}</span></td>
                <td className="px-2 py-2.5">
                  <div className="flex items-center gap-2">
                    <div className="flex-1 bg-zinc-800 rounded-full h-1.5 w-16">
                      <div className="h-1.5 rounded-full bg-violet-500" style={{ width: `${pct}%` }} />
                    </div>
                    <span className="text-[10px] text-zinc-500 font-mono w-8">{pct?.toFixed(0)}%</span>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="border-t border-zinc-700">
            <td className="px-2 py-2.5 text-xs font-bold text-zinc-300">Total</td>
            <td className="px-2 py-2.5 text-xs font-mono text-zinc-400">{GENERATION_DATA?.reduce((s, g) => s + g?.execCount, 0)}</td>
            <td className="px-2 py-2.5 text-xs font-mono text-zinc-400">{(totalGSV / 1000)?.toFixed(1)}K</td>
            <td colSpan={2} />
            <td className="px-2 py-2.5 text-sm font-bold font-mono text-emerald-400">${total?.toFixed(0)}</td>
            <td />
          </tr>
        </tfoot>
      </table>
    </div>
  );
}